<template>
  <main class="container" :class="{'container--is-visible' : showPage}">
    <slick class="slider" :ref="slick" :options="slickOptions">
      <div v-for="(img, index) in post.acf.images" :key="index">
        <div class="slider__item" :style="{ 'background-image': 'url(' + img.url+ ')' }"></div>
      </div>
    </slick>
    <single-post :post="post"></single-post>
  </main>
</template>

<script>
import axios from 'axios'
import slick from 'vue-slick'
import SinglePost from '../global/SinglePost.vue'

export default {
  name: 'Homepage',
  data () {
    return {
      title: '',
      post: [],
      loading: true,
      showPage: false,
      slick: '',
      slickOptions: {
        arrows: false,
        dots: false,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000,
        speed: 1000
      }
    }
  },

  created () {
    this.getPost()
  },

  updated () {
    this.showPage = true
  },

  methods: {
    getPost () {
      axios.get(process.env.API_URL + '/wp-json/wp/v2/pages/')
        .then(response => {
          this.post = response.data[0]
          this.loading = false

          if (this.post === undefined) {
            this.$router.push({name: 'NotFound'})
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  },

  components: {
    'single-post': SinglePost,
    'slick': slick
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage.vue